export default {
  userSettings: '/settings',
}
